import { AbstractControl } from "@angular/forms";


export function checkUnique(valueCompare: any, msg: string) {
  return (c: AbstractControl) => {
    return (valueCompare == c.value) ? {notUnique: msg} : null;
  };
}
